import { FileSpreadsheet, Users, Wallet, CalendarDays, Receipt, TrendingUp, Download } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";

const REPORTS = [
  { title: "Employee Master", desc: "Full list with code, dept, designation, CTC, status",
    path: "/api/reports/employees.csv", icon: Users },
  { title: "Payroll Register", desc: "Earnings/deductions per employee per month (CSV)",
    path: "/api/reports/payroll.csv", icon: Wallet },
  { title: "Attendance Logs", desc: "Daily attendance records across the workforce",
    path: "/api/reports/attendance.csv", icon: CalendarDays },
  { title: "TA/DA Claims", desc: "Tour advances, actual expenses & balance per claim",
    path: "/api/reports/tada.csv", icon: Receipt },
  { title: "Performance Targets", desc: "Sales / collection / scheme targets vs achievement",
    path: "/api/reports/performance.csv", icon: TrendingUp },
];

export default function Reports() {
  return (
    <div className="space-y-6" data-testid="reports-page">
      <header>
        <div className="kpi-label" style={{ color: "var(--color-secondary)" }}>Exports</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Reports</h1>
        <p className="text-stone-600 mt-1 text-sm">Download CSV exports of every operational stream.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="reports-grid">
        {REPORTS.map((r) => (
          <a key={r.title} href={`${BACKEND_URL}${r.path}`} target="_blank" rel="noopener noreferrer"
             data-testid={`download-${r.title.toLowerCase().replace(/\s|\//g, "-")}`}
             className="card-flat group hover:border-primary/40 transition flex items-start gap-4">
            <div className="w-12 h-12 rounded-md flex items-center justify-center shrink-0"
                 style={{ background: "var(--color-primary-light)" }}>
              <r.icon className="w-6 h-6" style={{ color: "var(--color-primary)" }} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-heading text-lg font-bold">{r.title}</div>
              <div className="text-sm text-stone-600 mt-1">{r.desc}</div>
              <div className="mt-3 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--color-primary)" }}>
                <Download className="w-4 h-4" /> Download CSV
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
